import React, {useCallback, useMemo, useState} from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import Close from "../../assets/image/icon_close.svg"
import {useAuth} from "@common/contexts/auth/AuthProvider";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import {isMobileApp} from "@common/utils/app/appUtils";
import {convertPath} from "@common/utils/path/linkPath";

function Menu() {
  const {adicUser, authenticated} = useAuth();

  const history = useHistory();

  const handleGoBack = useCallback(() => {
    history.goBack();
  },[])

  return (
    <div className="menu">
      <a onClick={handleGoBack} className="close-btn">
        <LazyLoadImage src={Close} alt=""/>
      </a>
      {
        isMobileApp() && !authenticated &&
        <div>
          <a href={convertPath('/login')} className="">
            로그인
          </a>
        </div>
      }
      <div>
        <a href={convertPath('/ad/tv')} className="">
          광고물 DB
        </a>
      </div>
      <div>
        <a href={convertPath('/recommend/theme')} className="">
          테마광고
        </a>
      </div>
      <div>
        <a href={convertPath('/forum/text')} className="">
          글로벌크리에이티브
        </a>
      </div>
      <div>
        <a href={convertPath('/magazine')} className="">
          매거진
        </a>
      </div>
      <div>
        <a href={convertPath('/lit/paper')} className="">
          전문자료
        </a>
      </div>
      <div>
        <a href={convertPath('/stat')} className="">
          광고통계
        </a>
      </div>
      <div>
        <a href={convertPath('/job')} className="">
          채용정보
        </a>
      </div>
    </div>
  )
}

export default Menu;
